import { getR7DocumentServerUrl } from '@/common/constants/r7DocumentServer'

function isLoopbackHost(host: string): boolean {
  const h = host.trim().toLowerCase()
  return h === 'localhost' || h === '127.0.0.1' || h === '::1' || h === '[::1]'
}

/** Предупреждение, если DS, скорее всего, не сможет скачать document.url (ошибка -4). */
export function validateOfficeEditorDocumentUrlForDocumentServer(documentUrl: string): string | null {
  let parsed: URL
  try {
    parsed = new URL(documentUrl)
  } catch {
    return 'Некорректный documentUrl из office-editor/prepare.'
  }

  const dsUrl = getR7DocumentServerUrl()
  let dsHost = ''
  try {
    dsHost = new URL(dsUrl).hostname
  } catch {
    /* ignore */
  }

  // Loopback в documentUrl при удалённом DS — DS не достучится до middleware на localhost браузера.
  if (isLoopbackHost(parsed.hostname) && dsHost && !isLoopbackHost(dsHost)) {
    return (
      `documentUrl указывает на ${parsed.hostname}, а Document Server на ${dsHost}. ` +
      'Задайте middle.office-editor.server-to-server.url=http://<IP>:1080/workflow-web-services/ на middleware.'
    )
  }

  return null
}

export function normalizeOfficeEditorPrepareUrls(urls: {
  documentUrl: string
  callbackUrl: string
}): { documentUrl: string; callbackUrl: string; urlWarning: string | null } {
  const urlWarning = validateOfficeEditorDocumentUrlForDocumentServer(urls.documentUrl)
  return {
    documentUrl: urls.documentUrl,
    callbackUrl: urls.callbackUrl,
    urlWarning,
  }
}
